export const i18nGetLocalizedTitle = (localizedData: object) => {
  if (!localizedData) return null
  return i18nGetLocalizedString(localizedData?.titles) || localizedData?.title
}
